import u from "./index881.js";
function i(r, e, t) {
  e == "__proto__" && u ? u(r, e, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : r[e] = t;
}
export {
  i as default
};
